export const SuccessKindType = {
  REGISTRATION_SUCCESS: 'REGISTRATION_SUCCESS',
  PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS',
  PASSWORD_RESET_LINK_SENT_SUCCESS: 'PASSWORD_RESET_LINK_SENT_SUCCESS',
} as const;
